module.exports = __webpack_public_path__ + "8a1d07439ec3d3652bfa205575c931fb.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/headers/golf-channel.jpg
 ** module id = 423
 ** module chunks = 0
 **/